export default {
      id: "linkedin-usage",
      viewBox: "0 0 60 60",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#linkedin-usage",
      toString: function () {
        return this.url;
      }
    }